export default __webpack_public_path__ + "static/media/image.innovator-park-international-pvt-ltd.ce40f37a.png";